import TheEnd from "../Views/TheEnd";

const routes = [{ path: "/the-end", element: <TheEnd /> }];

export default routes;
